import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TaskGroup } from 'dm-src/types/task-group';
import { TaskGroupItem } from 'dm-src/types/task-group-item';
import { TaskGroupItemType } from 'dm-src/types/task-group-item-type';
import { CollectingTaskListItem, DeliveryTaskState } from 'shared';

@Component({
    selector: '[task-group]',
    templateUrl: './task-group.component.html',
    styleUrls: ['./task-group.component.scss'],
})
export class TaskGroupComponent implements OnInit {
    @Input() public taskGroup: TaskGroup;
    @Input() public isCollapsed = true;
    @Input() public hasFrame = true;
    @Input() public useDynamicRouting = false;
    @Input() public showCollectingDividers = false;
    @Input() public hideDone = false;
    @Input() public badgeText: string;
    @Input() public showTaskBadges = true;
    @Output() public toggleRequested = new EventEmitter<void>();
    public dateFormat = 'yyyy. MMMM d.';

    constructor() {}

    ngOnInit(): void {}

    public requestToggle(): void {
        this.toggleRequested.emit();
    }

    public isLastCollectingTaskInSequence(index: number): boolean {
        const currentTask = this.taskGroup.tasks[index];

        if (
            !this.showCollectingDividers ||
            currentTask.taskType !== TaskGroupItemType.CollectingTask ||
            (this.hideDone && this.isDone(currentTask))
        ) {
            return false;
        }

        const nextVisibleTask = this.taskGroup.tasks
            .slice(index + 1)
            .find((task) => !this.hideDone || !this.isDone(task));

        return (
            !nextVisibleTask ||
            nextVisibleTask.taskType !== TaskGroupItemType.CollectingTask
        );
    }

    public getCollectingDeadline(index: number): Date {
        const task = this.taskGroup.tasks[index].task as CollectingTaskListItem;
        const estimatedStart = new Date(task.estimatedStartDate);

        return new Date(estimatedStart.getTime() + (task.pickingSeconds || 0) * 1000);
    }

    public get collectingTaskCount(): number {
        return this.getNotDoneTaskCount(TaskGroupItemType.CollectingTask);
    }

    public get deliveringTaskCount(): number {
        return this.getNotDoneTaskCount(TaskGroupItemType.DeliveringTask);
    }

    public get refundingTaskCount(): number {
        return this.getNotDoneTaskCount(TaskGroupItemType.RefundingTask);
    }

    public getTaskBadgeText(index: number): string {
        if (this.badgeText) {
            return this.badgeText;
        }

        const visibleTaskCount = this.taskGroup.tasks
            .slice(0, index + 1)
            .filter((task) => !this.hideDone || !this.isDone(task)).length;

        return visibleTaskCount.toString();
    }

    public isDone(taskGroupItem: TaskGroupItem): boolean {
        return taskGroupItem.task.state === DeliveryTaskState[DeliveryTaskState.Done];
    }

    private getNotDoneTaskCount(taskType: TaskGroupItemType): number {
        return (this.taskGroup?.tasks || []).filter(
            (item) => item.taskType === taskType && !this.isDone(item)
        ).length;
    }
}
